import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'


// 路由路径 url
const routes = [
  // 登录界面
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/appManage',
    name: 'appManage',
    meta: { title: 'userManage' },
    component: () => import('@/views/Main.vue'),
    children:[
      {
        path: '/appManage/bind-devices',
        name: 'bind-devices',
        meta: { title: 'bind-devices' },
        component: () => import('@/views/appManage/bind-devices.vue')
      },
      {
        path: '/appManage/app-user-detail',
        name: 'app-user-detail',
        meta: { title: 'app-user-detail' },
        component: () => import('@/views/appManage/app-user-detail.vue')
      }
      // {
      //   path: '/appManage/user-feedback',
      //   name: 'user-feedback',
      //   meta: { title: 'user-feedback' },
      //   component: () => import('@/views/appManage/user-feedback.vue')
      // }
    ]
  },
  {
    path: '/deviceManage',
    name: 'deviceManage',
    meta: { title: 'device' },
    component: () => import('@/views/Main.vue'),
    children: [
      {
        path: '/deviceManage/device-detail',
        name: 'device-detail',
        meta: { title: 'device-detail'},
        component: () => import('@/views/deviceManage/device-detail.vue')
      },
      {
        path: '/deviceManage/device-binder',
        name: 'device-binder',
        meta: { title: 'device-binder'},
        component: () => import('@/views/deviceManage/device-binder.vue')
      },
      {
        path: '/deviceManage/device-import-detail',
        name: 'device-import-detail',
        meta: { title: 'device-import-detail'},
        component: () => import('@/views/deviceManage/device-import-detail.vue')
      },
      {
        path: '/deviceManage/device-distribute',
        name: 'device-distribute',
        meta: { title: 'device-distribute'},
        component: () => import('@/views/deviceManage/device-distribute.vue')
      },
      {
        path: '/deviceManage/distributeDetail',
        name: 'distributeDetail',
        meta: { title: 'devicedistributeDetail'},
        component: () => import('@/views/deviceManage/distributeDetail.vue')
      },
      {
        path: '/deviceManage/instruction-detail',
        name: 'instruction-detail',
        meta: { title: 'instruction-detail'},
        component: () => import('@/views/deviceManage/instruction-detail.vue')
      },
    ]
  },
  {
    // path: '/userManage',
    name: 'system1',
    meta: { title: 'system' },
    component: () => import('@/views/Main.vue'),
    children: [
      {
        path: '/userManage/user-detail',
        name: 'user-detail',
        meta: { title: 'user-detail' },
        component: () => import('@/views/userManage/user-detail.vue')
      },
    ]
  },
]
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router